import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { FaLinkedin, FaInstagram, FaGithub } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import resumePDF from "../assets/resume/resume.pdf";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <FooterWrapper>
      <FooterInner>
        <BrandCol>
          <BrandName>Jim Montour</BrandName>
          <BrandTagline>
            PR Specialist · Fractional Consultant · Development Leader
          </BrandTagline>
          <SocialRow>
            <SocialIcon
              href="https://www.linkedin.com/in/jimmontour"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </SocialIcon>
            <SocialIcon
              href="https://www.instagram.com/jimmontour_/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </SocialIcon>
            <SocialIcon
              href="https://github.com/jimmontour"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
            >
              <FaGithub />
            </SocialIcon>
            <SocialIcon
              href="mailto:jimmontour@gmail.com"
              aria-label="Email"
            >
              <MdEmail />
            </SocialIcon>
          </SocialRow>
        </BrandCol>

        <LinkCols>
          <LinkCol>
            <ColHeading>Site</ColHeading>
            <FooterLink to="/">Home</FooterLink>
            <FooterLink to="/about">About</FooterLink>
            <FooterLink to="/consulting">Consulting</FooterLink>
            <FooterLink to="/work">Work</FooterLink>
          </LinkCol>

          <LinkCol>
            <ColHeading>Content</ColHeading>
            <FooterLink to="/blog">Blog</FooterLink>
            <FooterLink to="/media">In the News</FooterLink>
            <FooterLink to="/contact">Contact</FooterLink>
            <ExternalFooterLink href={resumePDF} target="_blank" rel="noopener noreferrer">
              Resume ↗
            </ExternalFooterLink>
          </LinkCol>
        </LinkCols>
      </FooterInner>

      <BottomBar>
        <span>© {year} Jim Montour. All rights reserved.</span>
        <span>Buffalo, NY</span>
      </BottomBar>
    </FooterWrapper>
  );
};

export default Footer;

// ---------------- Styled Components ----------------

const FooterWrapper = styled.footer`
  background: #111827;
  color: #9ca3af;
  margin-top: auto;
`;

const FooterInner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 3rem 2rem 2rem;
  display: flex;
  gap: 3rem;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const BrandCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 260px;
`;

const BrandName = styled.span`
  font-size: 1.1rem;
  font-weight: 700;
  color: #f9fafb;
  letter-spacing: -0.01em;
`;

const BrandTagline = styled.span`
  font-size: 0.8rem;
  color: #6b7280;
  line-height: 1.5;
`;

const SocialRow = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: 0.75rem;
`;

const SocialIcon = styled.a`
  color: #6b7280;
  font-size: 1.15rem;
  transition: color 0.2s;

  &:hover {
    color: #a5b4fc;
  }
`;

const LinkCols = styled.div`
  display: flex;
  gap: 3rem;
  flex-wrap: wrap;
`;

const LinkCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const ColHeading = styled.span`
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #f9fafb;
  margin-bottom: 0.25rem;
`;

const FooterLink = styled(NavLink)`
  font-size: 0.875rem;
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: #e5e7eb;
  }
`;

const ExternalFooterLink = styled.a`
  font-size: 0.875rem;
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: #e5e7eb;
  }
`;

const BottomBar = styled.div`
  border-top: 1px solid #1f2937;
  max-width: 1100px;
  margin: 0 auto;
  padding: 1.25rem 2rem;
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  color: #4b5563;

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 0.25rem;
    text-align: center;
  }
`;
